"use client"

import { Link, useNavigate } from "react-router-dom"
import { useAuth } from "../../../contexts/AuthContext"
import { ShieldExclamationIcon, ArrowLeftIcon, HomeIcon } from "@heroicons/react/24/outline"

export default function UnauthorizedPage() {
  const { user } = useAuth()
  const navigate = useNavigate()

  const getRoleDashboardRoute = (role) => {
    switch (role?.toLowerCase()) {
      case "superadmin":
        return "/su-admin"
      case "admin":
        return "/dash-admin"
      case "reseller":
        return "/dashreseller"
      default:
        return "/dashusers"
    }
  }

  const userDashboard = getRoleDashboardRoute(user?.role)

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 to-yellow-50 dark:from-gray-900 dark:to-gray-800 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white dark:bg-gray-800 rounded-3xl shadow-2xl p-8 text-center border border-red-100 dark:border-gray-700 relative overflow-hidden">
        {/* Decorative background glow */}
        <div className="absolute -top-12 -right-12 w-40 h-40 bg-red-500/10 rounded-full blur-2xl"></div>
        <div className="absolute -bottom-12 -left-12 w-40 h-40 bg-yellow-500/10 rounded-full blur-2xl"></div>

        {/* Warning Icon Badge */}
        <div className="w-20 h-20 bg-red-100 dark:bg-red-900/40 rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-inner">
          <ShieldExclamationIcon className="w-10 h-10 text-red-600 dark:text-red-400" />
        </div>

        {/* Header */}
        <h1 className="text-3xl font-extrabold text-gray-900 dark:text-white mb-2">
          403 - Not Authorized
        </h1>
        <p className="text-red-600 dark:text-red-400 font-semibold text-sm mb-4">
          Access Denied
        </p>

        {/* Message */}
        <p className="text-gray-600 dark:text-gray-300 text-sm mb-6 leading-relaxed">
          You are not authorized to access this URL. You do not have the required role permissions to view this dashboard page.
        </p>

        {/* Role Pill */}
        <div className="inline-flex items-center px-3 py-1 rounded-full bg-gray-100 dark:bg-gray-700 text-xs font-medium text-gray-700 dark:text-gray-300 mb-6">
          Logged in as: <span className="font-bold ml-1 uppercase text-red-600 dark:text-red-400">{user?.role || "guest"}</span>
        </div>

        {/* Action Button */}
        <div className="flex flex-col gap-3">
          <button
            onClick={() => navigate(userDashboard, { replace: true })}
            className="w-full py-3 px-4 bg-gradient-to-r from-red-600 to-yellow-600 hover:from-red-700 hover:to-yellow-700 text-white font-bold rounded-xl shadow-lg hover:shadow-xl transition-all flex items-center justify-center gap-2"
          >
            <HomeIcon className="w-5 h-5" />
            Go to My Authorized Dashboard
          </button>
        </div>
      </div>
    </div>
  )
}
